import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import { CalendarTwoTone } from '@ant-design/icons';
import classnames from 'classnames';
import styles from './styles.module.scss';

interface EventItemProps {
  title: string;
  imageUrl: string;
  date: string;
  eventId: string;
}
const EventItem = ({ title, imageUrl, date, eventId }: EventItemProps) => {
  const { i18n } = useTranslation();
  const router = useRouter();

  const onClick = () => {
    router.push(`/events/${eventId}`);
  };
  return (
    <div
      className="relative w-72 border-none overflow-hidden cursor-pointer rounded-lg"
      onClick={onClick}
      role="button"
      aria-label={`Event: ${title}`} // Provides a label for screen readers
      tabIndex={0} // Makes the div focusable
    >
      <div className="p-4 bg-transparent text-left text-gray-900 text-sm font-bold">
        <h2 className="flex items-center">
          <CalendarTwoTone twoToneColor="#575757" />
          &nbsp;{title}
        </h2>
      </div>
      <div className="relative">
        <img
          src={imageUrl || '/img/event-img-placeholder.png'}
          alt={title}
          className={classnames('w-full h-auto rounded-[24px]', {
            [styles['placeholder-image']]: !imageUrl
          })}
        />
        <div className="absolute top-4 right-2 inline-flex p-3 flex-col items-center gap-1 opacity-90 bg-white backdrop-blur-md rounded-lg">
          <span className="text-gray-800 text-sm font-semibold">
            {new Date(date).toLocaleString(i18n.language, { month: 'short' })}
            &nbsp;
          </span>
          <span className="text-gray-800 text-2xl font-semibold">
            {new Date(date).getDate()}{' '}
          </span>
        </div>
      </div>
    </div>
  );
};

export default EventItem;
